"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _shareWidget = _interopRequireDefault(require("../components/social/share-widget"));

require("./embeddable-share-widget.less");

var _util = require("../components/contentful-views/util");

var _commonPropTypes = require("../components/common-prop-types");

var _sections = require("../components/contentful-views/sections");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

/**
 * Maps to the Share Widget content model on Contentful
 * https://app.contentful.com/spaces/ljtyf78xujn2/content_types/shareWidget/fields
 * @param {Object} props
 * @param {String} props.position
 * @param {String} props.shareText
 * @param {String} props.shareUrl
 * @param {String} props.sites
 * @param {Object} props.stringSubstitutions
 */
var EmbeddableShareWidget = function EmbeddableShareWidget(_ref) {
  var position = _ref.position,
      shareText = _ref.shareText,
      shareUrl = _ref.shareUrl,
      sites = _ref.sites,
      stringSubstitutions = _ref.stringSubstitutions;
  // `position` refers to the side of the page we're on. The ShareWidget
  // should expand in the opposite direction.
  var expandDirection = position.match(/right$/) ? 'left' : 'right';
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "EmbeddableShareWidget fullWidth ".concat(position)
  }, /*#__PURE__*/_react["default"].createElement(_shareWidget["default"], {
    className: "wrapper",
    appearance: "round",
    sites: sites,
    expandDirection: expandDirection,
    url: shareUrl && (0, _util.stringSubstitution)(shareUrl, stringSubstitutions),
    text: shareText
  }));
};

EmbeddableShareWidget.propTypes = {
  sites: _propTypes["default"].arrayOf(_propTypes["default"].string).isRequired,
  position: _propTypes["default"].oneOf(['left', 'right']),
  shareUrl: _propTypes["default"].string,
  shareText: _propTypes["default"].string,
  stringSubstitutions: _commonPropTypes.stringSubstitutionsPropType
};
EmbeddableShareWidget.defaultProps = {
  position: 'left',
  // `undefined`, as opposed to null, allows the next component to use its default
  shareUrl: undefined,
  shareText: undefined,
  stringSubstitutions: {}
};
(0, _sections.registerWidget)('shareWidget', EmbeddableShareWidget);
var _default = EmbeddableShareWidget;
exports["default"] = _default;